var map = {
	"./icons/arrow-link.svg": "7ded",
	"./icons/arrow.svg": "a4d6",
	"./icons/check-solid.svg": "443c",
	"./icons/check.svg": "1eb1",
	"./icons/close.svg": "3ee6",
	"./icons/copy.svg": "4107",
	"./icons/exclamation.svg": "3ea1",
	"./icons/link.svg": "9fa3",
	"./icons/menu.svg": "cab7",
	"./icons/play.svg": "7e5f",
	"./icons/plus.svg": "a4b5",
	"./icons/social/discord.svg": "1b14",
	"./icons/social/facebook.svg": "be02",
	"./icons/social/instagram.svg": "7cee",
	"./icons/social/ok.svg": "f1e4",
	"./icons/social/reddit.svg": "c879",
	"./icons/social/steam.svg": "37e7",
	"./icons/social/telegram.svg": "3762",
	"./icons/social/tiktok.svg": "8042",
	"./icons/social/twitch.svg": "bcb8",
	"./icons/social/twitter.svg": "4f4b",
	"./icons/social/vk.svg": "0cd1",
	"./icons/social/vkplay.svg": "78ae",
	"./icons/social/youtube.svg": "0a61",
	"./icons/team.svg": "cdc3",
	"./icons/timer.svg": "31d2",
	"./icons/user.svg": "2fe8",
	"./icons/view-cards.svg": "ecb4",
	"./icons/view-rows.svg": "4672"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "592d";